export type NetCustomizeView = {
  uniformDiameter: boolean;
  uniformGap: boolean;
};

const isFiniteNumber = (value: unknown): boolean =>
  value !== null && value !== "" && Number.isFinite(Number(value));

export const getEditableTool = (edit: boolean, selectedTool: any): any | null =>
  edit && selectedTool?.tool && typeof selectedTool.tool === "object"
    ? selectedTool.tool
    : null;

export const getNetCustomizeView = (shape: any): NetCustomizeView => ({
  uniformDiameter:
    shape?.x_diameter?.steel_diameter === shape?.y_diameter?.steel_diameter,
  uniformGap: shape?.x_gap === shape?.y_gap,
});

export const isUsableNetCatalogShape = (shape: any): boolean =>
  Boolean(
    shape &&
      isFiniteNumber(shape.x_length) &&
      isFiniteNumber(shape.y_length) &&
      isFiniteNumber(shape.x_gap) &&
      isFiniteNumber(shape.y_gap) &&
      isFiniteNumber(shape.x_diameter?.steel_diameter) &&
      isFiniteNumber(shape.y_diameter?.steel_diameter)
  );

export const isUsablePileCatalogShape = (shape: any): boolean =>
  Boolean(
    shape &&
      isFiniteNumber(shape.hole_diameter) &&
      isFiniteNumber(shape.cage_diameter) &&
      isFiniteNumber(shape.l1_length) &&
      isFiniteNumber(shape.l2_length) &&
      isFiniteNumber(shape.l3_length) &&
      shape.base_diameter?.id &&
      shape.spiral_wire_diameter?.id
  );
export type PilePresentation = {
  base: boolean;
  sideSplit: 2 | 3;
};

export const getPilePresentation = (shape: any): PilePresentation => {
  const hasMiddleSection = shape?.middle_amount != null;
  const hasInternalSection = shape?.internal_amount != null;

  return {
    base: !(hasMiddleSection || hasInternalSection),
    sideSplit: hasMiddleSection ? 3 : 2,
  };
};

export const getPileDiameterId = (
  shape: any,
  field: "base_diameter" | "external_diameter" | "middle_diameter" | "internal_diameter" | "spiral_wire_diameter" | "ring_diameter"
): number | "" => shape?.[field]?.id ?? "";

// The current API returns a DiameterWeight object. Older saved tools returned
// the nominal diameter; retain that legacy conversion without discarding objects.
export const getPileRingDiameter = (value: any, diameters: any[] = []): any => {
  if (value == null) return null;
  if (typeof value === "object" && value.id) {
    return diameters.find(item => item.id === value.id) || value;
  }
  return diameters.find(item => Number(item.steel_diameter) === Number(value)) || null;
};

export const hasRequiredPileDiameters = (
  shape: any,
  base: boolean,
  sideSplit: number
): boolean => {
  if (!shape?.spiral_wire_diameter?.id) return false;
  if (base) return Boolean(shape?.base_diameter?.id);

  if (!shape?.external_diameter?.id || !shape?.internal_diameter?.id) {
    return false;
  }

  return sideSplit !== 3 || Boolean(shape?.middle_diameter?.id);
};
